export default __webpack_public_path__ + "static/media/48t.c82c7724.jpg";